import { apiClient } from "@/lib/apiClient";
import type {
  ApuracaoAjuste,
  ApuracaoDetalhe,
  ApuracaoIcms,
  ApuracaoIrpjCsll,
  ApuracaoPisCofins,
  TipoApuracao,
} from "../types/apuracao";

const BASE = "/api/contabil/apuracoes";

export const apuracaoService = {
  // Listagem por ano
  listarIcms: async (empresaId: number, ano: number) => {
    const { data } = await apiClient.get<ApuracaoIcms[]>(`${BASE}/icms`, {
      params: { empresaId, ano },
    });
    return data;
  },
  listarPisCofins: async (empresaId: number, ano: number) => {
    const { data } = await apiClient.get<ApuracaoPisCofins[]>(`${BASE}/pis-cofins`, {
      params: { empresaId, ano },
    });
    return data;
  },
  listarIrpjCsll: async (empresaId: number, ano: number) => {
    const { data } = await apiClient.get<ApuracaoIrpjCsll[]>(`${BASE}/irpj-csll`, {
      params: { empresaId, ano },
    });
    return data;
  },

  // Cálculo
  calcularIcms: async (empresaId: number, periodo: string) => {
    const { data } = await apiClient.post<ApuracaoIcms>(`${BASE}/icms/calcular`, {
      empresaId,
      periodo,
    });
    return data;
  },
  calcularPisCofins: async (empresaId: number, periodo: string) => {
    const { data } = await apiClient.post<ApuracaoPisCofins>(`${BASE}/pis-cofins/calcular`, {
      empresaId,
      periodo,
    });
    return data;
  },
  calcularIrpjCsll: async (empresaId: number, periodo: string) => {
    const { data } = await apiClient.post<ApuracaoIrpjCsll>(`${BASE}/irpj-csll/calcular`, {
      empresaId,
      periodo,
    });
    return data;
  },

  // Drill-down
  detalhe: async (tipo: TipoApuracao, id: number) => {
    const { data } = await apiClient.get<ApuracaoDetalhe>(`${BASE}/${tipo}/${id}/detalhe`);
    return data;
  },

  // Fechar / Reabrir
  fechar: async (tipo: TipoApuracao, id: number, usuarioId: number) => {
    await apiClient.post(`${BASE}/${tipo}/${id}/fechar`, { usuarioId });
  },
  reabrir: async (tipo: TipoApuracao, id: number, usuarioId: number) => {
    await apiClient.post(`${BASE}/${tipo}/${id}/reabrir`, { usuarioId });
  },

  // Ajustes manuais
  listarAjustes: async (tipo: TipoApuracao, id: number) => {
    const { data } = await apiClient.get<ApuracaoAjuste[]>(`${BASE}/${tipo}/${id}/ajustes`);
    return data;
  },
  criarAjuste: async (tipo: TipoApuracao, id: number, body: { valor: number; tributo?: string | null; descricao: string }) => {
    const { data } = await apiClient.post<ApuracaoAjuste>(`${BASE}/${tipo}/${id}/ajustes`, body);
    return data;
  },
  excluirAjuste: async (tipo: TipoApuracao, id: number, ajusteId: number) => {
    await apiClient.delete(`${BASE}/${tipo}/${id}/ajustes/${ajusteId}`);
  },
};
